// footer accordions

 window.addEventListener('DOMContentLoaded', () => {
    var acc = document.getElementsByClassName("static-footer-nav__title");
    var i;

    for (i = 0; i < acc.length; i++) {
      acc[i].addEventListener("click", function() {

        this.classList.toggle("active");

        var panel = this.nextElementSibling;
        if (panel.style.maxHeight) {
          panel.style.maxHeight = null;
          this.lastElementChild.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 2V22" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/><path d="M2 12H22" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>'
          panel.style.margin = '0 0 0'
        } else {
          panel.style.paddingTop = '0'
          panel.style.maxHeight = panel.scrollHeight + "px";
          panel.style.margin = '0 0 16px'
          this.lastElementChild.innerHTML = '<svg class="svg-minus" width="23" height="3" viewBox="0 0 23 3" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="23" height="3" rx="1.5" fill="white"/></svg>'
        }
      });
    }
 });


 // mobile header
 
 document.addEventListener('DOMContentLoaded', () => {

    let prevScroll = window.scrollY || document.documentElement.scrollTop;
    let curScroll;
    let direction = 0;
    let prevDirection = 0;
    let header_redes = document.querySelector('.site-header');
    let checkScroll = function() {
      curScroll = window.scrollY || document.documentElement.scrollTop;
      if (curScroll > prevScroll) { 
        direction = 2;
      }
      else if (curScroll < prevScroll) { 
        direction = 1;
      }
      if (direction !== prevDirection) {
        toggleHeader(direction, curScroll);
      }
      prevScroll = curScroll;
    };

    let toggleHeader = function(direction, curScroll) {
      if (direction === 2) { 
        header_redes.classList.add('hidden');
        prevDirection = direction;
      }
      else if (direction === 1) {
        setTimeout(() => {
          header_redes.classList.remove('hidden');
          prevDirection = direction;
        }, 400)
      }
    };

  window.addEventListener('scroll', checkScroll);

    let burgerMenu = document.querySelector('.burger-menu');
    let navBar = document.querySelector('.nav-bar');
    if (burgerMenu) {
      burgerMenu.addEventListener('click', () => {
        burgerMenu.classList.toggle('active');
        navBar.classList.toggle('toggle');
        document.body.classList.toggle('lock');
        //document.querySelector('.accessibility-new').classList.toggle('active');
        //document.querySelector('#solvvy-container').classList.toggle('active');
      })
    }

    const header = $('.header-redesign');

		$(window).scroll(function() {
			var scrolled = $(window).scrollTop();
		 
			if ( scrolled > 0 || !$('.announcement-bar')) {
				header.addClass('out');
			} else {
				header.removeClass('out');
			}
		});

    const search = document.querySelector('.site-header-actions__search-btn')
    const wrapper = document.querySelector('.search-block__wrapper.desktop');

    search.addEventListener('click', () => {
      wrapper.classList.toggle('active');
      search.classList.toggle('active');
    })
  })


 // announcement bar

   document.addEventListener('DOMContentLoaded', () => {
    let bar = document.querySelector('.announcement-bar');
    let close = bar.querySelector('.close');
    if (close) {
      close.addEventListener('click', () => {
        bar.style.display = "none";
        document.querySelector('.header-redesign').classList.add('out');
      })
    }

    const carouselSlider = document.querySelector('.carousel-slider');

    if (carouselSlider) {
      var swiper = new Swiper(carouselSlider, {});
    }
  })


// cart drawer

// document.addEventListener('DOMContentLoaded', () => {
//     let menuTrigger = document.querySelector('.site-header-cart--button');
//     let menuClose = document.querySelector('.rebuy-cart__flyout-close');
//     let samplesBlockTigger = document.querySelector('.samples-block__trigger');
//     let discountTigger = document.querySelector('.rebuy-input-label');
    
//    	menuTrigger.addEventListener('click', () => {
//    		document.querySelector('.rebuy-cart').classList.add('is-visible');
//    		document.querySelector('body').classList.add('rebuy-modal-visible');
//    	})
//    	menuClose.addEventListener('click', () => {
//    		document.querySelector('.rebuy-cart').classList.remove('is-visible');
//    		document.querySelector('body').classList.remove('rebuy-modal-visible');
//    	})
//    	samplesBlockTigger.addEventListener('click', () => {
//    		document.querySelector('.samples-block__content').classList.add('active');
//    	})
//    	discountTigger.addEventListener('click', () => {
//    		discountTigger.style.display="none";
//    		document.querySelector('.input-wrapper').classList.add('show');
//    	})
// })


// mega menu

$(".navmenu-id-shop").hover(function(){
	$('.site-main-dimmer').attr("data-animation-state", "open")
	$('.navmenu-item-parent > details').attr("open", "open");
	$('.navmenu-link-parent').attr("aria-expanded", true);
	$('.navmenu-meganav--desktop').attr("data-animation-state", "open").attr("data-animation", "closed=>open")
});

$(".site-main-dimmer").hover(function(){
	$(this).attr("data-animation-state", "closed")
	$('.navmenu-link-parent').attr("aria-expanded", false);
	$('.navmenu-meganav--desktop').attr("data-animation-state", "closed").removeAttr("data-animation")
});

$(".navmenu-depth-2 li").hover(function(){
  $(".navmenu-meganav-sidenav__item").removeClass("navmenu-item--preselected")
	$(this).addClass("alternate-drop")
	$(this).find("details").attr("open", "open")
	$(this).find("summary").attr("aria-expanded", true)
	$(this).find("ul").attr("data-animation-state", "open").attr("data-animation", "closed=>open")
}, function(){
	$(this).removeClass("alternate-drop")
	$(this).find("details").removeAttr("open")
	$(this).find("summary").attr("aria-expanded", false)
	$(this).find("ul").attr("data-animation-state", "closed").removeAttr("data-animation")
});